export enum EventStatusCodes {
    Unmoored = 'O',
    Moored = 'P',
    MoveUnmoored = 'R',
    Anchored = 'S',
    MoveMoore = 'T',
    Completed = 'Z',
    NearEvent = 'X'
}
